import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactApexChart from "react-apexcharts";
import { getDominanciaTalentosThunk } from "../../../store/reducers/dashboard/dominanciaTalentos/dominanciaTalentos.thunks";

// Color azul más intenso para mayor dominancia
const colorScale = (dominancia) => {
    // 0% = #E3E8F0 (gris claro), 100% = #2563EB (azul intenso)
    const min = 227, max = 37; // R/G/B for blue
    const v = Math.round(min + (max - min) * (dominancia / 100));
    return `rgb(${v},${v},255)`;
};

const CardDominanciaSimple = () => {
    const dispatch = useDispatch();
    const { dominanciaTalentos, loading, error } = useSelector(
        (state) => state.dominanciaTalentos
    );
    const { escuela, plantel } = useSelector((state) => state.dashboardFilters);

    useEffect(() => { dispatch(getDominanciaTalentosThunk()); }, [dispatch, escuela, plantel]);

    const sorted = [...dominanciaTalentos].sort((a, b) => b.dominancia - a.dominancia);
    const categories = sorted.map((t) => t.talento);
    const data = sorted.map((t) => t.dominancia);
    const colors = data.map(colorScale);

    const chartOptions = {
        chart: { type: "bar", toolbar: { show: false }, fontFamily: "inherit" },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                barHeight: "60%",
                distributed: true,
            },
        },
        colors,
        dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`,
            style: { fontSize: "13px", fontWeight: 600 },
            offsetX: -10,
        },
        xaxis: {
            categories,
            max: 100,
            title: { text: "Dominancia (%)" },
            labels: { style: { fontSize: "13px" } },
            //style: { fontWeight: 600 },
        },
        yaxis: { labels: { style: { fontSize: "13px" } } },
        tooltip: { y: { formatter: (val) => `${val.toFixed(1)}%` } },
        grid: {
            strokeDashArray: 4,
            padding: {
                right: 20,   // 👈 espacio extra a la derecha
            },
        },
        legend: { show: false },
    };

    const chartSeries = [{ name: "Dominancia", data }];

    return (
        <div className="col-6">
            <div className="card h-100">
                <div className="card-header">
                    <h6 className="mb-0 fw-bold text-lg">Dominancia de Talentos</h6>
                </div>
                <div className="card-body p-24" style={{ maxHeight: 600, overflowY: "auto" }}>
                    <p className="text-sm text-secondary-light mb-16">
                        Muestra qué talentos aparecen con mayor frecuencia y fuerza en las evaluaciones realizadas. <strong>Mientras más alto el porcentaje, más representa ese talento al grupo evaluado.</strong>
                    </p>
                    {loading && <div className="d-flex justify-content-center py-40">Cargando datos...</div>}
                    {error && <div className="alert alert-danger">Error cargando datos</div>}
                    {!loading && !error && sorted.length > 0 && (
                        <ReactApexChart
                            options={chartOptions}
                            series={chartSeries}
                            type="bar"
                            height={40 * sorted.length}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardDominanciaSimple;
